export const recaptchaConstants = {
  VALIDATE_RECAPTCHA: "VALIDATE_RECAPTCHA"
};
